module.exports = __webpack_public_path__ + "assets/jss.c62a1597.svg";